module.exports = __webpack_public_path__ + "static/media/ham.a3e474c3.svg";